export default __webpack_public_path__ + "static/media/abbv-blue.01a6eba8.svg";